import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import logo from "../assets/images/logo.png";
import "./goldDust.css";

const dustParticles = Array.from({ length: 100 });

const BRANCHES = ["Adalat Bazaar", "City Outlet", "Industrial Unit"];

export default function BranchLogin() {
  const [showPassword, setShowPassword] = useState(false);
  const [branch, setBranch] = useState(BRANCHES[0]);

  return (
    <div className="min-h-screen relative flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0b0b0f] via-[#12121a] to-[#0b0b0f]">
      {dustParticles.map((_, i) => (
        <span
          key={i}
          className="gold-dust"
          style={{
            left: `${Math.random() * 100}%`,
            width: `${Math.random() * 6 + 2}px`,
            height: `${Math.random() * 6 + 2}px`,
            animationDuration: `${Math.random() * 12 + 10}s`,
            animationDelay: `${Math.random() * 10}s`,
          }}
        />
      ))}

      <div className="absolute -top-32 -left-32 w-96 h-96 bg-amber-400/20 rounded-full blur-[140px]" />
      <div className="absolute -bottom-32 -right-32 w-96 h-96 bg-yellow-600/20 rounded-full blur-[140px]" />
      <div className="absolute inset-0 luxury-pattern" />

      <div className="relative z-10 w-full max-w-lg">
        <div
          className="
            rounded-[20px]
            bg-white/[0.035]
            backdrop-blur-[30px]
            border border-white/10
            px-10 py-12
            flex flex-col
            shadow-[0_60px_140px_rgba(0,0,0,0.85)]
          "
        >
          <div className="flex justify-center mb-8">
            <img
              src={logo}
              alt="Jaggi Sweets"
              className="w-14 h-14 opacity-90"
            />
          </div>

          <h1 className="text-[20px] uppercase text-center font-serif text-white">
            Jaggi Sweets
          </h1>
          <p className="mt-1 text-center text-[13px] text-gray-400">
            Sign in to manage your branch operations
          </p>

          <div className="bg-yellow-600 h-[3px] my-2 w-1/2 mx-auto" />

          <p className="mt-1 text-lg text-gray-400 text-center">
            Branch Access Portal
          </p>

          <div className="h-10" />

          <select
            value={branch}
            onChange={(e) => setBranch(e.target.value)}
            className="
              w-full
              bg-transparent
              border border-white/15
              rounded-xl
              px-4 py-3
              text-sm text-white
              focus:outline-none
              focus:border-amber-400
              transition
            "
          >
            {BRANCHES.map((b) => (
              <option
                key={b}
                value={b}
                className="bg-[#0b0b0f] text-white"
              >
                {b}
              </option>
            ))}
          </select>

          <input
            type="email"
            placeholder="Branch Login Email"
            className="
              w-full mt-4
              bg-transparent
              border border-white/15
              rounded-xl
              px-4 py-3
              text-sm text-white
              placeholder-gray-500
              focus:outline-none
              focus:border-amber-400
              transition
            "
          />

          <div className="relative w-full mt-4">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Password"
              className="
                w-full
                bg-transparent
                border border-white/15
                rounded-xl
                px-4 py-3 pr-10
                text-sm text-white
                placeholder-gray-500
                focus:outline-none
                focus:border-amber-400
                transition
              "
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2
                text-gray-400 hover:text-gray-200 transition"
            >
              {showPassword ? <EyeOff size={16} /> : <Eye size={16} />}
            </button>
          </div>

          <button
            type="submit"
            className="
              mt-6
              w-full
              rounded-xl
              bg-amber-400
              py-3
              text-sm
              font-medium
              text-black
              hover:bg-amber-300
              transition
            "
          >
            Enter Branch Dashboard
          </button>

          <div className="mt-8 text-center text-[11px] text-gray-500">
            Branch Restricted • Secure • Logged Access
          </div>
        </div>
      </div>
    </div>
  );
}
